<div class="draft-stage" [class]="'stage-' + stageView()">

  @switch (stageView()) {

    @case ('not_started') {
      <div class="ds-content ds-centered">
        <div class="ds-icon">
          <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
            <circle cx="12" cy="12" r="10"></circle>
            <polyline points="12 6 12 12 16 14"></polyline>
          </svg>
        </div>
        <h2 class="ds-serif">Draft Not Started</h2>
        <p class="ds-subtext">Waiting for the commissioner to start the draft</p>
        @if (isCommissioner) {
          <button class="ds-btn-primary" (click)="startDraft()">Start Draft</button>
        }
      </div>
    }

    @case ('choose_player') {
      @if (!selectedPlayer()) {
        <div class="ds-content ds-centered">
          <h2 class="ds-serif">Your turn to nominate</h2>
          <p class="ds-subtext">Pick a player from the player list to nominate</p>

          <div class="ds-card-stage">
            <div class="ds-decoy ds-decoy--left"></div>
            <div class="ds-decoy ds-decoy--right"></div>
            <div class="ds-hero-card ds-hero-card--mystery">
              <div class="ds-hero-portrait">
                <span class="ds-mystery-mark ds-serif">?</span>
              </div>
              <div class="ds-hero-footer">
                <div class="ds-hero-name ds-serif ds-mute">— — —</div>
              </div>
            </div>
          </div>

          @if (isCommissioner) {
            <app-gavel-options mode="nominating" [leagueId]="leagueId" [bottomStrip]="true" />
          }
        </div>
      } @else {
        <div class="ds-bidding-view">

          <!-- Meta strip -->
          <div class="ds-meta-strip">
            <span class="ds-mono ds-mute">YOUR NOMINATION</span>
            @if (socketService.countdownValue() !== null) {
              <span class="ds-timer ds-mono">⏱ {{ socketService.countdownValue() }}</span>
            }
          </div>

          <!-- Hero card stage -->
          <div class="ds-card-stage">
            <div class="ds-decoy ds-decoy--left"></div>
            <div class="ds-decoy ds-decoy--right"></div>
            <div class="ds-hero-card">
              <div class="ds-hero-pos-badge"
                   [class]="'ds-hero-pos-badge pos-' + selectedPlayer()!.position.toLowerCase()">
                {{ selectedPlayer()!.position }}
              </div>
              <div class="ds-hero-portrait">
                @if (selectedPlayer()!.photo) {
                  <img
                    [src]="selectedPlayer()!.photo"
                    [alt]="selectedPlayer()!.first_name + ' ' + selectedPlayer()!.last_name"
                  />
                } @else {
                  <svg width="100" height="100" viewBox="0 0 100 100" style="opacity:0.18">
                    <circle cx="50" cy="34" r="18" fill="currentColor"/>
                    <path d="M10 100 Q10 62 50 62 Q90 62 90 100 Z" fill="currentColor"/>
                  </svg>
                }
              </div>
              <div class="ds-hero-footer">
                <div class="ds-hero-name ds-serif">
                  {{ selectedPlayer()!.first_name }}<br>
                  {{ selectedPlayer()!.last_name }}
                </div>
                <div class="ds-hero-team ds-mono ds-mute">
                  {{ selectedPlayer()!.team }}
                </div>
              </div>
            </div>
          </div>

          <!-- Gavel strip (commissioner) -->
          @if (isCommissioner) {
            <app-gavel-options mode="nominating" [leagueId]="leagueId" />
          }

          <!-- Nomination dock -->
          <div class="ds-nom-dock">
<div class="ds-stepper">
              <button class="ds-stepper-btn" (click)="startingBid.set(startingBid() - 1)"
                [disabled]="startingBid() <= 1">−</button>
              <div class="ds-stepper-center">
                <div class="ds-bid-sublabel ds-mono">STARTING BID</div>
                <div class="ds-stepper-input">
                  <span class="ds-money-sign ds-serif">$</span>
                  <input
                    type="number"
                    class="ds-stepper-field"
                    [ngModel]="startingBid()"
                    (ngModelChange)="startingBid.set(+$event)"
                    min="1"
                  />
                </div>
              </div>
              <button class="ds-stepper-btn" (click)="startingBid.set(startingBid() + 1)">+</button>
            </div>
            <button class="ds-call-btn ds-serif" (click)="nominatePlayer()">Nominate</button>
          </div>

        </div>
      }
    }

    @case ('waiting_for_nomination') {
      <div class="ds-content ds-centered">
        <div class="ds-icon">
          <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
            <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
            <circle cx="8.5" cy="7" r="4"></circle>
            <line x1="20" y1="8" x2="20" y2="14"></line>
            <line x1="23" y1="11" x2="17" y2="11"></line>
          </svg>
        </div>
        <h2 class="ds-serif">Waiting for nomination</h2>
        <p class="ds-nominator">{{ socketService.currentNominatorName() }} is picking…</p>

        @if (isCommissioner) {
          <app-gavel-options
            mode="nominating"
            [leagueId]="leagueId"
            [bottomStrip]="true"
            [showNomFor]="!showCommissionerOverride()"
            (nomForClick)="showCommissionerOverride.set(true)"
          />

          <div class="ds-override-section">
            @if (showCommissionerOverride()) {
              <div class="ds-override-header">
                <span class="ds-label">Nominating for {{ currentNominatorInfo()?.userName }}</span>
                <button class="ds-btn-text" (click)="showCommissionerOverride.set(false); clearSelection()">Cancel</button>
              </div>

              @if (!selectedPlayer()) {
                <p class="ds-override-hint ds-mono ds-mute">Select a player from your watchlist or the player list.</p>
              } @else {
                <div class="ds-selected-card ds-selected-card--override">
                  <div>
                    <div class="ds-selected-name">{{ selectedPlayer()!.first_name }} {{ selectedPlayer()!.last_name }}</div>
                    <div class="ds-selected-pos">{{ selectedPlayer()!.position }} · {{ selectedPlayer()!.team }}</div>
                  </div>
                  <button class="ds-btn-text" (click)="clearSelection()">Change</button>
                </div>
                <div class="ds-bid-row">
                  <label class="ds-label">Starting bid</label>
                  <div class="ds-bid-input-wrap">
                    <span class="ds-currency">$</span>
                    <input
                      type="number"
                      class="ds-bid-input"
                      id="overrideStartingBid"
                      [ngModel]="startingBid()"
                      (ngModelChange)="startingBid.set($event)"
                      min="1"
                    />
                  </div>
                </div>
                <button class="ds-btn-warning-solid" (click)="nominatePlayerOnBehalf()">
                  Nominate for {{ currentNominatorInfo()?.userName }}
                </button>
              }
            }
          </div>
        }
      </div>
    }

    @case ('bid_on_player') {
      <div class="ds-bidding-view">

        <!-- Meta strip -->
        <div class="ds-meta-strip">
          <span class="ds-mono ds-mute">
            NOMINATED BY · {{ socketService.currentAuction()!.nominatedBy.name }}
            @if (socketService.currentAuction()!.nominatedByCommissioner) {
              <span class="ds-comm-badge">(via commissioner)</span>
            }
          </span>
          @if (socketService.countdownValue() !== null) {
            <span class="ds-timer ds-mono">⏱ {{ socketService.countdownValue() }}</span>
          }
        </div>

        <!-- Hero card stage -->
        <div class="ds-card-stage">
          <div class="ds-decoy ds-decoy--left"></div>
          <div class="ds-decoy ds-decoy--right"></div>
          <div class="ds-hero-card">
            <div class="ds-hero-pos-badge"
                 [class]="'ds-hero-pos-badge pos-' + socketService.currentAuction()!.player.position.toLowerCase()">
              {{ socketService.currentAuction()!.player.position }}
            </div>
            <div class="ds-hero-portrait">
              @if (socketService.currentAuction()!.player.photo) {
                <img
                  [src]="socketService.currentAuction()!.player.photo"
                  [alt]="socketService.currentAuction()!.player.first_name + ' ' + socketService.currentAuction()!.player.last_name"
                />
              } @else {
                <svg width="100" height="100" viewBox="0 0 100 100" style="opacity:0.18">
                  <circle cx="50" cy="34" r="18" fill="currentColor"/>
                  <path d="M10 100 Q10 62 50 62 Q90 62 90 100 Z" fill="currentColor"/>
                </svg>
              }
            </div>
            <div class="ds-hero-footer">
              <div class="ds-hero-name ds-serif">
                {{ socketService.currentAuction()!.player.first_name }}<br>
                {{ socketService.currentAuction()!.player.last_name }}
              </div>
              <div class="ds-hero-team ds-mono ds-mute">
                {{ socketService.currentAuction()!.player.team }}
              </div>
            </div>
          </div>
        </div>

        <!-- Gavel strip (commissioner) -->
        @if (isCommissioner) {
          <app-gavel-options
            mode="bidding"
            [leagueId]="leagueId"
            [bidOnBehalfUserId]="bidOnBehalfUserId()"
            [bidOnBehalfMaxBid]="bidOnBehalfMaxBid()"
            (bidOnBehalfChange)="bidOnBehalfUserId.set($event)"
          />
        }

        <!-- Bid dock -->
        <div class="ds-bid-dock">

          <!-- High bid -->
          <div class="ds-high-bid">
            <div class="ds-bid-sublabel ds-mono">HIGH BID</div>
            <div class="ds-high-bid-amount ds-serif">
              <span class="ds-money-sign">$</span>{{ socketService.currentAuction()!.currentBid }}
            </div>
            <div class="ds-high-bidder">{{ socketService.currentAuction()!.highBidder.name }}</div>
          </div>

          <!-- Stepper or max-bid warning -->
          @if (effectiveMaxBid() !== null && effectiveMaxBid()! <= socketService.currentAuction()!.currentBid) {
            <div class="ds-max-warning">
              @if (bidOnBehalfUserId() !== null) {
                {{ bidOnBehalfUserName() }} cannot bid higher — max ${{ effectiveMaxBid() }}
              } @else {
                You cannot bid higher — max ${{ effectiveMaxBid() }}
              }
            </div>
          } @else {
            <div class="ds-stepper">
              <button class="ds-stepper-btn" (click)="decrementBid()"
                [disabled]="customBidAmount() <= socketService.currentAuction()!.currentBid + 1">−</button>
              <div class="ds-stepper-center">
                <div class="ds-bid-sublabel ds-mono">YOUR BID</div>
                <div class="ds-stepper-input">
                  <span class="ds-money-sign ds-serif">$</span>
                  <input
                    type="number"
                    class="ds-stepper-field"
                    [ngModel]="customBidAmount()"
                    (ngModelChange)="customBidAmount.set($event)"
                    [min]="socketService.currentAuction()!.currentBid + 1"
                    [max]="effectiveMaxBid()"
                  />
                </div>
              </div>
              <button class="ds-stepper-btn" (click)="incrementBid()"
                [disabled]="effectiveMaxBid() !== null && customBidAmount() >= effectiveMaxBid()!">+</button>
            </div>
          }

          <!-- Call button -->
          @if (!(effectiveMaxBid() !== null && effectiveMaxBid()! <= socketService.currentAuction()!.currentBid)) {
            <button class="ds-call-btn ds-serif" (click)="placeCustomBid()"
              [disabled]="isBidOverMax(customBidAmount())">
              Call ${{ customBidAmount() }}
            </button>
          }

        </div>

      </div>
    }

    @case ('player_drafted') {
      <div class="ds-bidding-view">

        <!-- Meta strip: pick number -->
        <div class="ds-meta-strip">
          <span class="ds-mono ds-mute">
            {{ getOrdinal(socketService.draftSettings()?.draftHistory?.length || 0) }} PICK · SOLD
          </span>
        </div>

        @if (socketService.draftSettings()?.lastAuctionResult; as result) {

          <!-- Hero card stage -->
          <div class="ds-card-stage">
            <div class="ds-decoy ds-decoy--left"></div>
            <div class="ds-decoy ds-decoy--right"></div>
            <div class="ds-hero-card">
              <div class="ds-hero-pos-badge"
                   [class]="'ds-hero-pos-badge pos-' + result.player.position.toLowerCase()">
                {{ result.player.position }}
              </div>
              <div class="ds-hero-portrait">
                @if (result.player.photo) {
                  <img
                    [src]="result.player.photo"
                    [alt]="result.player.first_name + ' ' + result.player.last_name"
                  />
                } @else {
                  <svg width="100" height="100" viewBox="0 0 100 100" style="opacity:0.18">
                    <circle cx="50" cy="34" r="18" fill="currentColor"/>
                    <path d="M10 100 Q10 62 50 62 Q90 62 90 100 Z" fill="currentColor"/>
                  </svg>
                }
              </div>
              <div class="ds-hero-footer">
                <div class="ds-hero-name ds-serif">
                  {{ result.player.first_name }}<br>
                  {{ result.player.last_name }}
                </div>
                <div class="ds-hero-team ds-mono ds-mute">{{ result.player.team }}</div>
              </div>
            </div>
          </div>

          <!-- Result dock -->
          <div class="ds-result-dock">
            <div>
              <div class="ds-bid-sublabel ds-mono">ACQUIRED BY</div>
              <div class="ds-result-dock-winner ds-serif">{{ result.winner.name }}</div>
            </div>
            <div class="ds-result-dock-cost">
              <span class="ds-money-sign ds-serif">$</span>{{ result.amount }}
            </div>
          </div>

        }

        <!-- Next nomination / waiting -->
        <div class="ds-result-actions">
          @if (isCommissioner) {
            <button class="ds-btn-primary" (click)="advanceDraft()">Next Nomination</button>
          } @else {
            <p class="ds-waiting-text">Waiting for commissioner to continue…</p>
          }
        </div>

      </div>
    }

    @case ('draft_paused') {
      <div class="ds-content ds-centered">
        <h2 class="ds-serif">Draft Paused</h2>
        <p class="ds-subtext">The draft has been temporarily paused</p>

        <div class="ds-card-stage">
          <div class="ds-decoy ds-decoy--left"></div>
          <div class="ds-decoy ds-decoy--right"></div>
          <div class="ds-hero-card ds-hero-card--mystery">
            <div class="ds-hero-portrait">
              <svg width="56" height="56" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2">
                <rect x="6" y="4" width="4" height="16"></rect>
                <rect x="14" y="4" width="4" height="16"></rect>
              </svg>
            </div>
            <div class="ds-hero-footer">
              <div class="ds-hero-name ds-serif ds-mute">— — —</div>
            </div>
          </div>
        </div>

        @if (isCommissioner) {
          <app-gavel-options mode="paused" [leagueId]="leagueId" [bottomStrip]="true" />
        }
      </div>
    }

    @case ('draft_ended') {
      <div class="ds-content ds-centered">
        <div class="ds-icon ds-icon--success">
          <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
            <path d="M8.21 13.89 7 23l5-3 5 3-1.21-9.11"></path>
            <path d="M19 8a7 7 0 1 0-14 0"></path>
            <path d="M12 1v7"></path>
          </svg>
        </div>
        <h2 class="ds-serif">Draft Complete!</h2>
        <p class="ds-subtext">All players have been drafted. Check the results below.</p>
      </div>
    }
  }
</div>
